<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter"
      :style="headerStyle"
    ></parallax>
    <div class="main main-raised">
      <div class="section profile-content">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-50 mx-auto">
              <div class="profile">
                <div class="avatar">
                  <img
                    :src="img"
                    alt="Circle Image"
                    class="img-raised rounded img-fluid"
                    style="background: white;"
                  />
                </div>
                <div class="name">
                  <h3 class="title">Participación en congresos</h3>
                </div>
              </div>
            </div>
          </div>
          <div class="md-layout-item md-size-100 mx-auto">
            <div class="table-responsive">
              <table class="table">
          
                <tbody>
                  <tr>
                   
                    <td>Dulce R. Herrera Moro, Agustín García Reynoso, Olmo Zavala Romero, Bertha E. Mar Morales, Pedro
Cruz Santiago, Pavel E. Oropeza Alfaro. Description and impact of the new HPC infrastructure on
the Air Quality Forecast in CCA UNAM, 9th International Supercomputing Conference in Mexico
(ISUM 2018), Mérida Yucatán 9 marzo 2018</td>
                    
                  </tr>
                  <tr>
                             <td>Agustín García Reynoso, Jorge Zavala Hidalgo, Hugo Delgado Granados, Dulce R. Herrera Moro. The use of HPC on Volcanic Tephra Dispersion Operational Forecast System, 9th International
Supercomputing Conference in Mexico (ISUM 2018), Mérida Yucatán 9 marzo 2018</td>
                  </tr>
                  
                </tbody>
              </table>
            </div>
            <br />
            <br />
          </div>
         

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tabs } from "@/components";
export default {
  components: {
   
  },
  bodyClass: "profile-page",
  data() {

  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/vue-mk-header.jpg")
    },
    img: {
      type: String,
      default: require("@/assets/img/congress.png")
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}
</style>
